import { PulseEnvironment } from '../../globals';
import { DataLayerItem } from '../../models';

export class EventAdapterService {
    constructor(private env: PulseEnvironment) {}

    push(event: DataLayerItem) {
        if (this.env.win?.dataLayer) {
            this.env.win.dataLayer.push(event as any);
        }
    }
}
